<template>
  <v-container>
    <v-layout row wrap align-center class="ma-10">
      <v-flex>
        <router-link to="/upload">
          <v-card>
            <v-container>
              <v-layout>
                <v-flex>
                  <div class="headline font-weight-bold text-center">
                    Upload attachments for new ticket
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </router-link>
      </v-flex>
    </v-layout>
    <v-layout row wrap align-center class="ma-10">
      <v-flex>
        <router-link to="/view">
          <v-card>
            <v-container>
              <v-layout>
                <v-flex>
                  <div class="headline font-weight-bold text-center">
                    View uploaded files for attachment code
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </router-link>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "LandingPage"
};
</script>
